import { useEffect, useState } from "react";
import { useClassNames } from "@/hooks/useClassNames";
import { PipelinesMenu } from "@/types/domain";
import { fetchPipelinesMenu } from "@/api/menu/api";

export const PipelinesSubMenu = () => {
  const [pipelinesData, setPipelinesData] = useState<PipelinesMenu | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetchPipelinesMenu(window.location.href)
      .then((data) => {
        setPipelinesData(data ?? null);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  if (!loaded) {
    return <li className="px-3 py-1 text-xs text-(--layout-side-nav-header)">Loading…</li>;
  }

  if (!pipelinesData?.pipelines.length) {
    return <li className="px-3 py-1 text-xs text-(--layout-side-nav-header)">No pipelines</li>;
  }

  return (
    <>
      {pipelinesData.pipelines.map((p) => (
        <li key={p.id}>
          <a
            href={`/Pipeline/Index/${p.id}`}
            className={useClassNames(
              "block px-3 py-1.5 text-xs truncate rounded-l-2xl ml-1",
              pipelinesData.selectedPipelineId === p.id
                ? "text-white bg-(--layout-side-nav-active-bg)"
                : "text-(--layout-side-nav-text) hover:bg-white hover:text-black"
            )}
          >
            {p.name}
          </a>
        </li>
      ))}
    </>
  );
}
